import { faCheck, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

interface NotificationRowVaccineApprovalStatusProps {
    status?: string;
}

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            marginTop: 4
        },
        badge: {
            display: 'inline-flex',
            height: 27,
            padding: '4px 11px',
            alignItems: 'center',
            gap: 5,
            borderRadius: 100,
            textAlign: 'center',
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: 'Poppins',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px',
            textTransform: 'capitalize'
        },
        approvedStatus: {
            background: '#E9F0ED',
            color: '#5E8677'
        },
        declinedStatus: {
            background: '#FFE5E7',
            color: '#CC444B'
        }
    })
);

const NotificationRowVaccineApprovalStatus: React.FC<NotificationRowVaccineApprovalStatusProps> = ({ status }) => {
    const classes = useStyles();
    const normalized = status?.toLowerCase();

    if (normalized === 'approved') {
        return (
            <div className={classes.root}>
                <div className={clsx(classes.badge, classes.approvedStatus)}>
                    <FontAwesomeIcon icon={faCheck} />
                    Approved
                </div>
            </div>
        );
    }

    if (normalized === 'rejected' || normalized === 'declined') {
        return (
            <div className={classes.root}>
                <div className={clsx(classes.badge, classes.declinedStatus)}>
                    <FontAwesomeIcon icon={faTimes} />
                    Declined
                </div>
            </div>
        );
    }

    return null;
};

export default NotificationRowVaccineApprovalStatus;
